document.addEventListener('DOMContentLoaded', function() {
    const secActuators = document.querySelectorAll('.recommended-pr-item');
  
  
  
    const tempStrokeHtml ='<option value="0" data-as-value="0">Stroke</option>';
    $('.field select[name="actuator_stroke"]').html(tempStrokeHtml);
  
    const tempActuatorHtml ='<option value="0" data-as-value="0">Actuator</option>';
    $('.field select[name="actuator_product"]').html(tempActuatorHtml);
  
  
    let actuatoCount = 1;
    let temporaryHtml = '';
    let boxweight = $(this).find(':input[name="box_weight"]').val();
    let ipCondition = 1;
    let weightCount = boxweight;
    let customerSpeed = 0;
    let obj = {};
    let actuatorVoltage = 12;
  
    actuatorFilter();
   
  
      //Change calculator type
      $('.calculator-types .container').on('click', function () {
        $('.calculator-types .container').removeClass('active');
        $('.calc-types-block').removeClass('active');
        
        $(this).addClass('active');
        
        var calcType = $(this).data('type');
        console.log(calcType)
        if (calcType == 'dynamic-box') {
          location.href = '/pages/calculator';
        }
        $('.section-descr-wrapper').removeClass('active');
        $('.section-descr-wrapper[data-type="'+ calcType +'"]').addClass('active');
        $('.calc-types-block[data-type="'+ calcType +'"]').addClass('active');
  
      })
  
  
  
    secActuators.forEach(function(actuator) {
      const retractedArr = [];
      const extendedArr = [];
  
      const tr = actuator.querySelectorAll('.actuator-lenght tr:not(:first-child)');
      if(tr.length > 0){
        tr.forEach(function(el) {
            const cells = el.querySelectorAll('td');
            if(cells.length > 0){
              retractedArr.push(cells[1].innerText);
              extendedArr.push(cells[2].innerText);
            }
  
        })
      }
      actuator.setAttribute('data-retracted', retractedArr);
      actuator.setAttribute('data-extended', extendedArr);
    });
  
  
  
    function getAUrlParams(url) {
        var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
        
    
        if (queryString) {
          queryString = queryString.split('#')[0];
    
          var arr = queryString.split('&');
    
          for (var i = 0; i < arr.length; i++) {
            var a = arr[i].split('=');
            var paramName = a[0];
            var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
            paramName = paramName.toLowerCase();
    
            if (paramName.match(/\[(\d+)?\]$/)) {
    
              var key = paramName.replace(/\[(\d+)?\]/, '');
              if (!obj[key]) obj[key] = [];
    
              if (paramName.match(/\[\d+\]$/)) {
                var index = /\[(\d+)\]/.exec(paramName)[1];
                obj[key][index] = paramValue;
              } else {
                obj[key].push(paramValue);
              }
            } else {
              if (!obj[paramName]) {
                obj[paramName] = paramValue.replace(/%2C/g,',');
              } else if (obj[paramName] && typeof obj[paramName] === 'string'){
                obj[paramName] = [obj[paramName]];
                obj[paramName].push(paramValue.replace(/%2C/g,','));
              } else {
                obj[paramName].push(paramValue.replace(/%2C/g,','));
              }
            }
          }
        }
        return obj;
        
    }
  
    function updateUParameters() {
        var qString = '?type='+$('.calc-types-block.active').data('param');
  
        $('.calc-types-block.active').find('.field').each(function(){
          var param_value = "";
          var t_param_value = $(this).find(':input').val();
    
          if($(this).attr('data-param') == 'ipc'){
            t_param_value = $(this).find('input[name="ipc"]:checked').data('ipc-number');
            
          }
          if($(this).attr('data-param') == 'ac'){
            t_param_value = $(this).find('input[name="actuator_count"]:checked').data('ac-number');
          }
    
    
          if($(this).attr('data-param') == 'bw'){
            t_param_value = $(this).find(':input[name="box_weight"]').val();
            boxweight = t_param_value;
          }
    
          if($(this).attr('data-param') == 'sp'){
            t_param_value = $(this).find(':input[name="speed"]').val();
            actuatorSpeed = t_param_value;
          }
          if($(this).attr('data-param') == 'as'){
            t_param_value = $(this).find(':selected').data('as-value');
          }
    
          if($(this).find(':input').length > 0){
            qString += (qString == '' ? '?' : '&');
            qString += $(this).attr('data-param') + '=' + t_param_value;
          }
        });
  
        window.history.pushState(null, null, qString);
        getAUrlParams(window.location.href);
        
    }
    updateUParameters();
    var params = getAUrlParams(window.location.href);
  
  
    //Scroll to calculator section
    $("#button-scroll").click(function() {
        if ($(window).width() <= 1199){
          $("html, body").animate({
            scrollTop: ($("#scroll-section").offset().top - $('.site-header').height())
          }, 1e3);
        }else{
          $("html, body").animate({
            scrollTop: ($("#scroll-section").offset().top - 50)
          }, 1e3);
        }
      });
  
    function changeVal(el, valTemp){
        if(el.closest('.one__moreless').find('input[name="box_width"]').length > 0){
          el.closest('.calc-specs').find($('input[name="lid_mount_position"]')).attr('max', valTemp);
          el.closest('.calc-specs').find($('input[name="lid_mount_position"]')).val(valTemp/2);
          el.closest('.calc-specs').find($('input[name="lid_mount_position"]')).next().html(valTemp/2);
        }
  
    };
  
      $('.calc-types-block .one__more').on('click', function() {
        var valTemp = +$(this).parents('.one__moreless').find('input[type=number]').val();
        var maxVal = +$(this).parents('.one__moreless').find('input[type=number]').attr('max');
        valTemp++;
        if (valTemp > maxVal){
          valTemp = maxVal;
        }
        $(this).parents('.one__moreless').find('input[type=number]').val(valTemp);
        changeVal($(this), valTemp);
        vchangeParams();
        actuatorFilter();
    
      });
    
      $('.calc-types-block .one__less').on('click', function() {
        var valTemp = +$(this).parents('.one__moreless').find('input[type=number]').val();
        valTemp--;
        if(valTemp <= 0) {
          valTemp = 1;
        }
        $(this).parents('.one__moreless').find('input[type=number]').val(valTemp);
        changeVal($(this), valTemp);
        vchangeParams();
        actuatorFilter();
      });
    
      $('input[type="number"]').on('change', function (e) {
        e.preventDefault();
        var valTemp = +$(this).parents('.one__moreless').find('input[type=number]').val();
        var maxVal = +$(this).parents('.one__moreless').find('input[type=number]').attr('max');
        if(maxVal){
          if (valTemp < maxVal && valTemp > 0) {
            changeVal($(this), $(this).val())
          }else if(valTemp >= maxVal && valTemp > 0){
            +$(this).parents('.one__moreless').find('input[type=number]').val( maxVal);
            changeVal($(this), maxVal);
          }else{
            +$(this).parents('.one__moreless').find('input[type=number]').val(1);
            changeVal($(this), 1)
          }
          vchangeParams()
        }else{
          var val =$(this).val();
          if(val <= 0 ){
            val = 1;
          }
          changeVal($(this), val);
          vchangeParams();
          actuatorFilter();
  
        }
      
      })
    
  
      $('#speedRange').on("input", function() {
        customerSpeed = $(this).val();
        actuatorFilter();
      });
  
  
      $('input[type="range"]').on("input", function() {
        $(this).next().html($(this).val());
        vchangeParams();
      });
  
  
    function svgModify() {
      const actuatorLeft = document.querySelector('#actuator_l');
      const actuatorCenter = document.querySelector('#actuator_c');
      const actuatorRight = document.querySelector('#actuator_r');
  
  
      actuatorLeft.classList.add("invisible");
      actuatorCenter.classList.remove("invisible");
      actuatorRight.classList.add("invisible");
  
      actuatoCount = $("input[name='actuator_count']:checked").data('ac-number');
  
      switch(actuatoCount) {
        case 1:
          actuatorLeft.classList.add("invisible");
          actuatorRight.classList.add("invisible");
          break;
        case 2:
          actuatorLeft.classList.remove("invisible");
          actuatorCenter.classList.add("invisible");
          actuatorRight.classList.remove("invisible");
          break;
        case 3:
          actuatorLeft.classList.remove("invisible");
          actuatorCenter.classList.remove("invisible");
          actuatorRight.classList.remove("invisible");
          break;
        case 4:
          actuatorLeft.classList.remove("invisible");
          actuatorCenter.classList.add("invisible");
          actuatorRight.classList.remove("invisible");
          break;
      };
  
  
    }
  
    svgModify();
  
  
    function actuatorFilter() {
        
       
        $('.data-output').removeClass('active');
        $('#stroke-selecto').removeClass('active');
  
        ipCondition = $("input[name='ipc']:checked").data('ipc-number');
        actuatoCount = $("input[name='actuator_count']:checked").data('ac-number');
        actuatorVoltage = $("input[name='actuator_voltage']:checked").data('vds-number');
        //create array from all actuators
        const itemsArray = Array.from(secActuators);
     
  
        let force;
        let filteredArr =[];
        filteredArr.splice(0,filteredArr.length);
  
        const condition_1 = ['IP20','IP43','IP65','IP66','IP66M','IP67M','IP68M','IP69K', 'IP54'];
        const condition_2 = ['IP65','IP66','IP66M','IP67M','IP68M','IP69K'];
        const condition_3 = ['IP66M','IP67M','IP68M','IP69K'];
        const condition_4 = ['IP67M','IP68M','IP69K'];
        const condition_5 = ['IP68M','IP69K'];
  
  
        function filerActuators(ip,count) {
          filteredArr = itemsArray.filter(function(actuator){
            let force_val;
            
            // old value speed:
            // let fulLoadSpeed = +actuator.dataset.speedFullload;
            // let noLoadSpeed = +actuator.dataset.speedNoload;
            let fulLoadSpeed = parseFloat(actuator.dataset.speedFullloadRange.split(',')[0]);
            let noLoadSpeed = parseFloat(actuator.dataset.speedNoloadRange.split(',')[0]);
  
            let protection = actuator.dataset.protection;
  
            let protectionCheck = false;
            let voltageCheck = false;
            let two_data = actuator.dataset.dbTwo;
            let three_data = actuator.dataset.dbThree;
            let four_data = actuator.dataset.dbFour;
  
            let voltage = actuator.dataset.voltage;
  
            switch(actuatorVoltage) {
              case 7:
                if(voltage == '7.4 VDC|12 VDC') {
                  voltageCheck = true;
                  console.log('voltageCheck',voltageCheck)
                };
                break;
              case 12:
                if(voltage == '12 VDC' || voltage == '12 VDC|24 VDC' || voltage == '7.4 VDC|12 VDC') {
                  voltageCheck = true;
                };
                break;
              case 24:
                if(voltage == '24 VDC' || voltage == '12 VDC|24 VDC') {
                  voltageCheck = true;
                };
                break;
            };
          
  
            force = actuator.getAttribute("data-force").split('|').map(function(elem) {
                return +elem.replace(' lbs', '');
            })
            force_val = Math.max.apply(null, force);
  
            
            force_speed = Math.min.apply(null, force);
  
            let slope,speed;  
            slope = (fulLoadSpeed - noLoadSpeed)/(force_speed - 0);
            speed = (slope * weightCount) + noLoadSpeed;
  
  
            switch(ip) {
              case 1:
                if(condition_1.includes(protection)) {
                  protectionCheck = true;
                };
                break;
              case 2:
                if(condition_2.includes(protection)) {
                  protectionCheck = true;
                };
                break;
              case 3:
                if(condition_3.includes(protection)) {
                  protectionCheck = true;
                };
                break;
              case 4:
                if(condition_4.includes(protection)) {
                  protectionCheck = true;
                };
                break;
              case 5:
                if(condition_5.includes(protection)) {
                  protectionCheck = true;
                };
                break;
            };
  
            switch(count) {
              case 1:
                return force_val > weightCount && protectionCheck && speed > customerSpeed && voltageCheck;
                break;
              case 2:
                return two_data == 'true' && force_val > weightCount && protectionCheck && speed > customerSpeed && voltageCheck;
                break;
              case 3:
                return three_data == 'true' && force_val > weightCount && protectionCheck && speed > customerSpeed && voltageCheck;
                break;
              case 4:
                return four_data == 'true' && force_val > weightCount && protectionCheck && speed > customerSpeed && voltageCheck;
                break;
            };
          })
  
  
        }
  
        filerActuators(ipCondition,actuatoCount);
  
        filteredArr.sort((a,b) => {
          if(+a.dataset.price < +b.dataset.price) return 1;
          if(+a.dataset.price > +b.dataset.price) return -1;
          return 0;
        });
  
  
  
        temporaryHtml = '';
        $('.field select[name="actuator_product"]').html('');
        $('.field select[name="actuator_product"]').append(temporaryHtml);
       
        if (filteredArr.length > 0) {
            $('.product-item').html('');
            $('.recomm-products-wrapper').html('');
  
            filteredArr.forEach(function(elem){
                let productId = +elem.getAttribute("data-product-id");
                const recommendedWrapper = document.querySelector('.recomm-products-wrapper');
                let recommId = $('.actuator-products').find('.recommended-pr-item[data-product-id="' + productId + '"]').html();
  
         
                recommendedWrapper.insertAdjacentHTML('afterbegin',recommId);
            })
        } else {
            $('.recomm-products-wrapper').html('');
            $('.product-item').html('');
        }
  
  
        changeActuatorStroke($('.field select[name="actuator_product"]'));
  
        document.getElementById('stroke-selector').classList.add('hiddenDiv');
        const recommendedProducts = document.querySelectorAll('.recommend-product-card');
        let selectedRecPrId;
        let selectedForce;
  

        recommendedProducts.forEach((productCard)=>{
          productCard.addEventListener('click', event => {
            document.querySelector('.actuator-sroke-selected').textContent = '';
    
            recommendedProducts.forEach(el=>el.classList.remove('selected'))
            productCard.classList.add('selected')
            selectedRecPrId = +productCard.dataset.productCard
  
           
            recommendedSelector(selectedRecPrId);
            changeActuatorStroke(selectedRecPrId);
  
            document.getElementById('stroke-selector').classList.remove('hiddenDiv');
  
          })
        })
    
  
        const resultsContainer = document.querySelector('.calc-types-section');
        let resultsContainerRect = resultsContainer.getBoundingClientRect();
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        var shouldUpdateScroll = scrollTop > resultsContainerRect.top
        if(shouldUpdateScroll) {

            resultsContainer.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "nearest"
            });
        }
  
    };
  
  
  
    $('.field select[name="actuator_product"]').on("change", function() {
        let selectedProductId = $('.field select[name="actuator_product"]').find('option:selected').val();
        let selectedAktuator = document.querySelector(`[data-product-card="${selectedProductId}"]`);
        let allProductCards = document.querySelectorAll('.recommend-product-card');
        allProductCards.forEach(el => el.classList.remove('selected'));
        selectedAktuator.classList.add('selected');
  
        changeActuatorStroke($(this));
        
    });
  
  
  
  
  
    function changeActuatorForce(allData) {
      let tempHtml ='<option value="0" data-force-value="0">Force</option>';
      $('.field select[name="actuator_force"]').html('');
  
      
      let forceRange = allData.force.split('|');
  
      forceRange.forEach((el, index)=>{
        tempHtml += '<option data-index="' + index + '" data-force-value="' + el.replace(' lbs', 'lbs') + '" value="' + el + '" data-force="' + el.replace(' lbs', '') + '">' + el + '</option>';
      })
      $('.field select[name="actuator_force"]').append(tempHtml);
    }
  
  
  
  
  
  
  
    function changeActuatorStroke(id) {
  
      var tempHtml ='<option value="0" data-as-value="0">Stroke</option>';
      $('.field select[name="actuator_stroke"]').html('');
  
      var actuatorStrokeData = $('.actuator-products').find('.recommended-pr-item[data-product-id="' + id + '"]').data('stroke');
      if (typeof actuatorStrokeData == 'string') {
          var actuatorStroke = $('.actuator-products').find('.recommended-pr-item[data-product-id="' + id + '"]').data('stroke').split('|');
          actuatorStroke.forEach(function(el, index){
          tempHtml += '<option data-index="' + index + '" data-as-value="' + el.replace(' inch', 'inch') + '" value="' + el + '" data-stroke="' + el.replace(' inch', '') + '">' + el + '</option>';
          });
      }
      $('.field select[name="actuator_stroke"]').append(tempHtml);
  }
  
    $('.field select[name="actuator_product"], .field select[name="actuator_stroke"]').on("change", function() {
        $(this).attr("selected","selected");
        strokeSelector();
      });
  
      $('.field select[name="actuator_force"]').on("change", function() {
        $(this).attr("selected","selected");
        forceSelector();
      });
  
  
  
    function recommendedSelector(id) {
      
      $('.data-output').removeClass('active');
      $('.recommended-block  .title').text('').removeClass('active');
      var conditions = $('select[name="actuator_conditions"] option:selected').val();
      var actuator_count = +$('input[name="actuator_count"]:checked').data('ac-number');
      var $this = $('.actuator-products').find('.recommended-pr-item[data-product-id="' + id + '"]');
      const ipText = document.querySelector('.actuator-ip');
      const qtText = document.querySelector('.actuator-qty');
      const weightText = document.querySelector('.actuator-weight');
      const speedtText = document.querySelector('.actuator-speed');
      const voltageText = document.querySelector('.actuator-voltage');
      const strokeText = document.querySelector('.actuator-stroke');
      const forceText = document.querySelector('.actuator-force');
      actuatorVoltage = $("input[name='actuator_voltage']:checked").data('vds-number');
      let allData = $this.data();
      let force_val;

      
  
      speedtText.textContent = '';
      let force = allData.force.split('|').map(function(elem) {
        return +elem.replace(' lbs', '');
      })
      force_val = Math.min.apply(null, force);
  
      const boxesContainer = document.querySelector('.calculator_boxes');
      var tempHtml ='<span class="actuator-spec-note label">Compatible control boxes:</span>';
      // boxesContainer.html('');
      boxesContainer.innerHTML = '';
      
  
      // console.log('allData ',allData)
      // console.log('actuator_count ',actuator_count)
      // console.log('actuatorVoltage ',actuatorVoltage)
  
      let controlBoxes = [];
  
            


      if(actuator_count == 1 && allData.dbCtrlBoxes) {
        controlBoxes = allData.dbCtrlBoxes.split('|')
        if (controlBoxes.length > 0) {
          controlBoxes.forEach(function(box) {
            let boxUrl = box.split(':')[0];
            let boxSKU = box.split(':')[1];
   
            tempHtml += '<a href="' + boxUrl + '" target="_blank">' + boxSKU + '</a> ';
          })
          boxesContainer.innerHTML = tempHtml;
        }
      } else if (actuator_count == 2 && actuatorVoltage == 12 && allData.dbTwoBoxes) {
        controlBoxes = allData.dbTwoBoxes.split('|')
        if (controlBoxes.length > 0) {
          controlBoxes.forEach(function(box) {
            let boxUrl = box.split(':')[0];
            let boxSKU = box.split(':')[1];
   
            tempHtml += '<a href="' + boxUrl + '" target="_blank">' + boxSKU + '</a> ';
          })
          boxesContainer.innerHTML = tempHtml;
        }
      } else if (actuator_count == 2 && actuatorVoltage == 24 && allData.twoHightvBoxes) {
        controlBoxes = allData.twoHightvBoxes.split('|')
        if (controlBoxes.length > 0) {
          controlBoxes.forEach(function(box) {
            let boxUrl = box.split(':')[0];
            let boxSKU = box.split(':')[1];
   
            tempHtml += '<a href="' + boxUrl + '" target="_blank">' + boxSKU + '</a> ';
          })
          boxesContainer.innerHTML = tempHtml;
        }
      } else if(actuator_count == 3  && actuatorVoltage == 12 && allData.dbThreeBoxes) {
        controlBoxes = allData.dbThreeBoxes.split('|')
        if (controlBoxes.length > 0) {
          controlBoxes.forEach(function(box) {
            let boxUrl = box.split(':')[0];
            let boxSKU = box.split(':')[1];
   
            tempHtml += '<a href="' + boxUrl + '" target="_blank">' + boxSKU + '</a> ';
          })
          boxesContainer.innerHTML = tempHtml;
        }
      } else if(actuator_count == 3 && actuatorVoltage == 24 && allData.threeHightvBoxes) {
        controlBoxes = allData.threeHightvBoxes.split('|')
        if (controlBoxes.length > 0) {
          controlBoxes.forEach(function(box) {
            let boxUrl = box.split(':')[0];
            let boxSKU = box.split(':')[1];
   
            tempHtml += '<a href="' + boxUrl + '" target="_blank">' + boxSKU + '</a> ';
          })
          boxesContainer.innerHTML = tempHtml;
        }
      } else if(actuator_count == 4 && actuatorVoltage == 12 && allData.dbFourBoxes) {
          controlBoxes = allData.dbFourBoxes.split('|')
          if (controlBoxes.length > 0) {
            controlBoxes.forEach(function(box) {
              let boxUrl = box.split(':')[0];
              let boxSKU = box.split(':')[1];
     
              tempHtml += '<a href="' + boxUrl + '" target="_blank">' + boxSKU + '</a> ';
            })
            boxesContainer.innerHTML = tempHtml;
          }
      } else if(actuator_count == 4 && actuatorVoltage == 24 && allData.fourHightvBoxes) {
        controlBoxes = allData.fourHightvBoxes.split('|')
        if (controlBoxes.length > 0) {
          controlBoxes.forEach(function(box) {
            let boxUrl = box.split(':')[0];
            let boxSKU = box.split(':')[1];
    
            tempHtml += '<a href="' + boxUrl + '" target="_blank">' + boxSKU + '</a> ';
          })
          boxesContainer.innerHTML = tempHtml;
        }
      } else {
        boxesContainer.innerHTML = '';
      }
      
  
  
      if(force.length>1) {
        changeActuatorForce(allData);
        document.getElementById('force-selector').classList.remove('hiddenDiv');
      } else {
        singleForcespped(force[0])
        document.getElementById('force-selector').classList.add('hiddenDiv');
      }
  
      
  
      let voltageRange;  
      let voltageRangeText = '';
  
  
      let strokeRange = allData.stroke.split('|');
      let strokeRangeText = strokeRange[0].replace(' inch', '') + ' - ' + strokeRange[strokeRange.length - 1];
  
      if (allData.voltage) {
        voltageRange = allData.voltage.split('|');
        if(voltageRange.length > 1) {
          voltageRangeText = voltageRange[0].replace(' VDC', '') + ' - ' + voltageRange[voltageRange.length - 1];
        } else {
          voltageRangeText = voltageRange[0];
        }
      }
  
  
      let forceRange = allData.force.split('|');
      let forceRangeText;
      if(forceRange.length > 1) {
        forceRangeText = forceRange[0].replace(' lbs', '') + ' - ' + forceRange[forceRange.length - 1];
      } else {
        forceRangeText = forceRange[0];
      }
  
  
      
  
      if(id != null) {
        
        $('.data-output').addClass('active');
  
        ipText.textContent = allData.protection;
        qtText.textContent = actuator_count;
        weightText.textContent = weightCount + ' lbs';
        
        voltageText.textContent = voltageRangeText;
        strokeText.textContent = strokeRangeText;
        forceText.textContent = forceRangeText;
        document.querySelector('.actuator-sroke-extended').textContent = '';
        document.querySelector('.actuator-sroke-retracted').textContent = '';
  
      }
    }
  
  
  
    function forceSelector() {
      let id = document.querySelector('.recommend-product-card.selected').dataset.productCard;
      let $this = $('.actuator-products').find('.recommended-pr-item[data-product-id="' + id + '"]');
      const speedtText = document.querySelector('.actuator-speed');
      let slope,speed;
      let allData = $this.data();
      let selectedForce = $('.field select[name="actuator_force"]').find('option:selected').val().replace(' lbs', '');
      const selectedForceIndex = $('.field select[name="actuator_force"]').find('option:selected').data('index');
  

      let fulLoadSpeed = parseFloat(allData.speedFullloadRange.split(',')[selectedForceIndex]);
      let noLoadSpeed = parseFloat(allData.speedNoloadRange.split(',')[selectedForceIndex]);
  
      slope = (fulLoadSpeed - noLoadSpeed)/(+selectedForce - 0)
      speed = (slope * weightCount) + noLoadSpeed
  
      if(selectedForce != 0 ) {
        speedtText.textContent = speed.toFixed(2) + ' in/s';
      } else {
        speedtText.textContent = '';
      }

    }
  
    function singleForcespped(force) {
      let id = document.querySelector('.recommend-product-card.selected').dataset.productCard;
      let $this = $('.actuator-products').find('.recommended-pr-item[data-product-id="' + id + '"]');
      const speedtText = document.querySelector('.actuator-speed');
      let slope,speed;
      let allData = $this.data();
      let singleForce = +force;
      let fulLoadSpeed = +allData.speedFullload;
      let noLoadSpeed = +allData.speedNoload;

  
      slope = (fulLoadSpeed - noLoadSpeed)/(+singleForce - 0)
      speed = (slope * weightCount) + noLoadSpeed
      speedtText.textContent = speed.toFixed(2) + ' in/s';
  
    }
  
  
    function strokeSelector() {
        let id = document.querySelector('.recommend-product-card.selected').dataset.productCard;
        let $this = $('.actuator-products').find('.recommended-pr-item[data-product-id="' + id + '"]');
        const strokeText = document.querySelector('.actuator-sroke-selected');
        const extendedText = document.querySelector('.actuator-sroke-extended');
        const retractedText = document.querySelector('.actuator-sroke-retracted');
        let allData = $this.data();
  
        var stroke_length = $('.field select[name="actuator_stroke"]').find('option:selected').val();
        var stroke_index = $('.field select[name="actuator_stroke"]').find('option:selected').data('index')
        strokeText.textContent = stroke_length;
  
        var retracted = parseFloat($this.data('retracted').split(',')[stroke_index]);
        var extended = parseFloat($this.data('extended').split(',')[stroke_index]);
        extendedText.textContent = extended + ' inch';
        retractedText.textContent = retracted + ' inch';
        
    }
  
  
    
    function weightCalulator() {
        actuatoCount = $("input[name='actuator_count']:checked").data('ac-number');
        if (actuatoCount == 1) {
          weightCount = boxweight;
        } else {
          weightCount = (boxweight / actuatoCount + (boxweight / actuatoCount ) / 4).toFixed(2);
          console.log('weightCount-->',weightCount)
        }
        return weightCount;
      }
  
  
  
  
  
    $("input[name='ipc']").on("input", function() {
        vchangeParams();
        actuatorFilter(); 
    });
  
  
    $("input[name='actuator_count']").on("input", function() {
        vchangeParams();
        actuatorFilter();
        svgModify();
    });
    $("input[name='actuator_voltage']").on("input", function() {
        vchangeParams();
        actuatorFilter();
    });
  
      function vchangeParams() { 
        updateUParameters();
        weightCalulator();
      }
  
  })